import { MLSListing } from '@aloft/toolkit-shared';

import { AlertsSheet } from './AlertsSheet/AlertsSheet.tsx';
import { ClientInformationSheet } from './ClientInformationSheet/ClientInformationSheet.tsx';
import { InspectionReportSheet } from './InspectionReportSheet/InspectionReportSheet.tsx';
import { Tkv2MlsDataSheet } from './MLSDataSheet/Tkv2MlsDataSheet.tsx';
import { PdfSheet } from './PdfSheet/PdfSheet.tsx';
import { Tkv2PublicRecordSheet } from './PublicRecordSheet/Tkv2PublicRecordSheet.tsx';
import { ReconciliationSheet } from './ReconciliationSheet/ReconciliationSheet.tsx';
import { Tkv2MlsImages } from './Tkv2MlsImages.tsx';
import { MLSMap } from './Tkv2MlsMap/MLSMap.tsx';
import { Tkv2MlsStreetView } from './Tkv2MlsStreetView.tsx';
import { Tkv2SiteValue } from './Tkv2SiteValue/Tkv2SiteValue.tsx';
import { ReferenceViewID } from './index.ts';
import { DataSheet } from './types.ts';

export const Tkv2DataComponent = ({
  referenceViewID,
  dataSheet,
  isPopout,
  listingData,
  address,
}: {
  referenceViewID: ReferenceViewID;
  dataSheet: DataSheet | null;
  isPopout: boolean;
  listingData?: MLSListing;
  address?: string;
}) => {
  // TODO: Better undefined handling
  switch (dataSheet) {
    case 'mls-listing':
      return (
        <Tkv2MlsDataSheet
          isPopout={isPopout}
          referenceViewID={referenceViewID}
          listingData={listingData ?? {}}
        />
      );
    case 'mls-images':
      return (
        <Tkv2MlsImages
          listingData={listingData ?? {}}
          isPopout={isPopout}
          referenceViewID={referenceViewID}
        />
      );
    case 'mls-map':
      return <MLSMap isPopout={isPopout} />;
    case 'mls-street-view':
      return (
        <Tkv2MlsStreetView
          isPopout={isPopout}
          listingData={listingData ?? {}}
          address={address ?? ''}
        />
      );
    case 'public-record':
      return <Tkv2PublicRecordSheet referenceViewID={referenceViewID} />;
    case 'craftsman-alerts':
      return <AlertsSheet />;
    case 'site-analysis':
      return <Tkv2SiteValue isPopout={isPopout} />;
    case 'client-information':
      return <ClientInformationSheet />;
    case 'reconciliation':
      return <ReconciliationSheet />;
    case 'pdf':
      return <PdfSheet />;
    case 'inspection-report':
      return <InspectionReportSheet referenceViewID={referenceViewID} />;
    default:
      return null;
  }
};
